import { UserPageHeader } from '../../../../pages/user-page/header/user-page-header';
import { UserPage } from '../../../../pages/user-page/user-page';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';
import { UserType } from '../../../../api/types/user/user-type';

export interface UserPageDialogDatamodel {
  selectedUser: UserSummaryType | undefined;
  setSelectedUser: (user: UserSummaryType | undefined) => void;
  closeDialog: () => void;
  onHide: () => void;
  userRole: UserType | undefined;
}

export const UserPageDialog: React.FC<UserPageDialogDatamodel> = ({
  selectedUser,
  setSelectedUser,
  closeDialog,
  onHide,
  userRole,
}) => {
  return (
    <Dialog
      header={() => {
        return (
          <UserPageHeader
            userRole={userRole}
            setSelectedUser={setSelectedUser}
            selectedUser={selectedUser}
          />
        );
      }}
      showHeader={true}
      visible={selectedUser !== undefined}
      style={{
        height: '95vh',
        width: '95vw',
        minWidth: '1100px',
        paddingTop: '16px',
        borderRadius: '8px',
        backgroundColor: '#f0f8ff',
      }}
      headerStyle={{ backgroundColor: '#f0f8ff' }}
      onHide={onHide}
    >
      <div>
        {selectedUser && (
          <UserPage
            userRole={userRole}
            closeDialog={closeDialog}
            user={selectedUser!}
          />
        )}
      </div>
    </Dialog>
  );
};
